<template>
    <ModalComponent :name="'edit-' + entrada.id" title="Editar entrada">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="name">{{ $t('formularios.nombre') }}</label>
                    <input id="name" type="text" v-model="entrada.user_nombre"/>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="surnames">{{ $t('formularios.apellidos') }}</label>
                    <input id="surnames" type="text" v-model="entrada.user_apellidos"/>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="dni">{{ $t('formularios.dni') }}</label>
                    <input id="dni" type="text" v-model="entrada.user_dni"/>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group" v-if="errors">
                    <div class="alert alert-danger" role="alert">
                        <ul>
                            <template v-for="(error, index) in errors.errors">
                                <li :key="index">
                                    {{ error[0] }}
                                </li>
                            </template>                                                
                        </ul>
                    </div>
                </div>
            </div>                
            <div class="col-12 d-flex justify-content-between">
                <button class="button mr-3" @click.prevent="update">{{ $t('perfil.guardar') }}</button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from '@/components/backend/components/ModalComponent';

    export default {
        props: {
            entrada: Object
        },
        data() {
            return {
                errors: null
            }
        },
        methods: {
            close() {
                this.$emit('close', 'edit-' + this.entrada.id);
            },
            update() {
                const data = {
                    user_nombre: this.entrada.user_nombre,
                    user_apellidos: this.entrada.user_apellidos,
                    user_dni: this.entrada.user_dni,
                    user_order_id: this.entrada.tpv_order,
                    user_ticket_id: this.entrada.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.ticket.update'), data).then(res => {
                    this.$toast.success(this.$t('perfil.datos_editados'));
                    this.close();
                }).catch(error => {
                    this.errors = error.response.data; 
                });
                
            }
        }, 
        components: {
            ModalComponent
        }
    }
</script>
